import DashboardWalletData from './DashboardWalletData';
export default DashboardWalletData;
